import KdiagramCalculationResultCalculationInputData from "./data";

export default function mapCalculationInputFromJson(json) {
  return new KdiagramCalculationResultCalculationInputData(
    json["date"] ? new Date(json["dates"]["mindate"]) : new Date(),
    json["date"] ? new Date(json["dates"]["maxdate"]) : new Date(),
    json["trim"],
    json["draft"],
    json["wind_bft"],
    json["wind_knots"],
  );

}
